/**
 * @generated SignedSource<<00583b5291a72f524506d30ea62066c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProductRequiredFieldEnum = "customer_info" | "delivery_info" | "student_info" | "%future added value";
export type ProductShowTypeEnum = "non_registered" | "private" | "repurchase" | "store" | "upgrade" | "%future added value";
export type ProductCreateInput = {
  additionalDiscountAmount?: number | null;
  description?: string | null;
  discountPrice: number;
  price: number;
  requiredFields: ReadonlyArray<ProductRequiredFieldEnum>;
  showTypes: ReadonlyArray<ProductShowTypeEnum>;
  storeStuff: string;
  title: string;
};
export type ProductCreateDialog_productCreateMutation$variables = {
  input: ProductCreateInput;
};
export type ProductCreateDialog_productCreateMutation$data = {
  readonly productCreate: {
    readonly id: string;
  };
};
export type ProductCreateDialog_productCreateMutation = {
  response: ProductCreateDialog_productCreateMutation$data;
  variables: ProductCreateDialog_productCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Product",
    "kind": "LinkedField",
    "name": "productCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductCreateDialog_productCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductCreateDialog_productCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe76b7fcab422cc4f2db92f9633d7eb4",
    "id": null,
    "metadata": {},
    "name": "ProductCreateDialog_productCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ProductCreateDialog_productCreateMutation(\n  $input: ProductCreateInput!\n) {\n  productCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "584993cc87ad9a8857e988410a25d258";

export default node;
